import Search from '@material-ui/icons/Search';
import React from 'react';

export function SearchIcon() {
  return <Search />;
}
